import PropTypes from 'prop-types';
import CheckboxInput from './CheckboxInput';
import DateInput from './DateInput';
import RadioInput from './RadioInput';
import TextInput from './TextInput';

const getInputComponent = (type, props) => {
  const components = {
    TEXT: <TextInput {...props} key={props.id} />,
    MULTIPLE_CHOICE: <RadioInput {...props} key={props.id} />,
    CHECKBOX: <CheckboxInput {...props} key={props.id} />,
    DATE: <DateInput {...props} key={props.id} />,
  };
  return components[type] || null;
};

const Section = ({ setValue, forms, values }) => (
  <>
    {forms.map((form) =>
      getInputComponent(form.type, {
        ...form,
        setValue,
        values,
      }),
    )}
  </>
);

Section.propTypes = {
  setValue: PropTypes.func,
  forms: PropTypes.array,
  values: PropTypes.shape(),
};

export default Section;
